import NavLinks from "./NavLinks";
import './Navbar.css';

const DesktopNavigation = () =>{
    return(
        <nav className="DesktopNavigation">
            <NavLinks />
        </nav>
    )
}

export default DesktopNavigation;